import { v4 as uuidv4 } from 'uuid';
import differenceBy from 'lodash/differenceBy';

export const createOrderNotification = (
    oldOrders,
    newOrders,
    oldFingerprintCallingWaiter,
    oldFingerprintClosingBill,
    newClientNameCallingWaiter,
    newClientNameClosingBill,
    newFingerprintCallingWaiter,
    newFingerprintClosingBill,
    fingerprint,
    selectAreOrdersFetched
) => {
    if (!selectAreOrdersFetched) {
        return null;
    }

    const createdOrdersCount = newOrders.length - oldOrders.length;

    if (createdOrdersCount > 0) {
        const createdOrders = differenceBy(newOrders, oldOrders, 'id');

        const newOrderPosition = createdOrders[0].positions[0];

        if (newOrderPosition.clientFingerprint !== fingerprint) {
            return { notificationIcon: 'icon-basket',
                notificationMessageTranslationKey: 'App.orderCreatedByOtherUser',
                notificationMessageTranslationParameters: { userName: newOrderPosition.clientName } };
        } else {
            return { notificationIcon: 'icon-basket',
                notificationMessageTranslationKey: 'App.orderCreatedByUser',
                notificationMessageTranslationParameters: null };
        }
    }

    if (newOrders.length > 0 && oldOrders.length > 0) {
        const createdPositions = differenceBy(newOrders[0].positions, oldOrders[0].positions, 'id');

        if (createdPositions.length > 0) {
            const createdPosition = createdPositions[0];

            if (createdPosition.clientFingerprint !== fingerprint) {
                return { notificationIcon: 'icon-basket',
                    notificationMessageTranslationKey: 'App.positionCreatedByOtherUser',
                    notificationMessageTranslationParameters: { userName: createdPosition.clientName } };
            } else {
                return { notificationIcon: 'icon-basket',
                    notificationMessageTranslationKey: 'App.positionCreatedByUser',
                    notificationMessageTranslationParameters: null };
            }
        }
    }

    if (newOrders.length > 0 && oldOrders.length > 0) {
        const deletedPositions = differenceBy(oldOrders[0].positions, newOrders[0].positions, 'id');

        if (deletedPositions.length > 0) {
            const deletedPosition = deletedPositions[0];

            if (deletedPosition.clientFingerprint !== fingerprint) {
                return { notificationIcon: 'icon-basket',
                    notificationMessageTranslationKey: 'App.positionDeletedByOtherUser',
                    notificationMessageTranslationParameters: { userName: deletedPosition.clientName } };
            } else {
                return { notificationIcon: 'icon-basket',
                    notificationMessageTranslationKey: 'App.positionDeletedByUser',
                    notificationMessageTranslationParameters: null };
            }
        }
    }

    if (newOrders.length > 0 && oldOrders.length > 0) {
        if (oldOrders[0].fingerprintPlacingOrder !== newOrders[0].fingerprintPlacingOrder) {
            if (newOrders[0].fingerprintPlacingOrder !== fingerprint) {
                return { notificationIcon: 'icon-basket',
                    notificationMessageTranslationKey: 'App.orderPlacedByOtherUser',
                    notificationMessageTranslationParameters: { userName: newOrders[0].clientNamePlacingOrder } };
            } else {
                return { notificationIcon: 'icon-basket',
                    notificationMessageTranslationKey: 'App.orderPlacedByUser',
                    notificationMessageTranslationParameters: null };
            }
        }
    }

    if (oldFingerprintClosingBill !== newFingerprintClosingBill) {
        if (newFingerprintClosingBill !== fingerprint) {
            return { notificationIcon: 'icon-basket',
                notificationMessageTranslationKey: 'App.billClosedByOtherUser',
                notificationMessageTranslationParameters: { userName: newClientNameClosingBill } };
        } else {
            return { notificationIcon: 'icon-basket',
                notificationMessageTranslationKey: 'App.billClosedByUser',
                notificationMessageTranslationParameters: null };
        }
    }

    if (oldFingerprintCallingWaiter !== newFingerprintCallingWaiter
        && newFingerprintCallingWaiter !== null) {
        if (newFingerprintCallingWaiter !== fingerprint) {
            return { notificationIcon: 'icon-call-waiter',
                notificationMessageTranslationKey: 'App.waiterCalledByOtherUser',
                notificationMessageTranslationParameters: { userName: newClientNameCallingWaiter } };
        } else {
            return { notificationIcon: 'icon-call-waiter',
                notificationMessageTranslationKey: 'App.waiterCalledByUser',
                notificationMessageTranslationParameters: null };
        }
    }

    if (newOrders.length > 0 && oldOrders.length > 0) {
        const completedOrdersNotifications = oldOrders
            .reduce((result, oldOrder, index) => {
                if (oldOrder.status !== newOrders[index].status && newOrders[index].status === 3) {
                    return { notificationIcon: 'icon-basket',
                        notificationMessageTranslationKey: 'App.orderCompleted',
                        notificationMessageTranslationParameters: { orderNumber: newOrders.length - index } };
                }

                return result;
            }, []);

        if (!Array.isArray(completedOrdersNotifications)) {
            return completedOrdersNotifications;
        }
    }

    return null;
};

export const createBillNotification = (
    oldlastBillPaid,
    newlastBillPaid,
    selectAreOrdersFetched
) => {
    if (!selectAreOrdersFetched) {
        return null;
    }

    if (oldlastBillPaid !== newlastBillPaid && newlastBillPaid) {
        return { notificationIcon: 'icon-basket',
            notificationMessageTranslationKey: 'App.billPaid' };
    }

    return null;
};

export const calculateAddonsPrice = (addonGroups = []) => addonGroups.reduce(
    (groupSum, addonGroup) => groupSum + addonGroup.addons.reduce(
        (addonsSum, addon) => {
            if (addon.isSelected || addon.quantity || addonGroup.selectedAddon === addon.virtualId) {
                return addonsSum + addon.price * (addon.quantity || 1) + calculateAddonsPrice(addon.addonGroups) * (addon.quantity || 1);
            }

            return addonsSum;
        },
        0
    ),
    0
);

export const calculatePrice = (menuPosition) => menuPosition.price + calculateAddonsPrice(menuPosition.addonGroups);

export function getControlType(element) {
    if (element.addons && element.addons.every((position) => position.maxQuantity <= 1)) {
        if (element.minQuantity === 1 && element.maxQuantity === 1) {
            return 'radio';
        }

        return 'checkbox';
    }

    if (element.addons && element.addons.some((position) => position.maxQuantity > 1 && position.addonGroups.length)
        && element.maxQuantity > 0) {
        return 'configurable';
    }

    return 'multi';
}

export const prepareConfigurablePosition = (position) => ({
    ...position,
    virtualId: uuidv4(),
    quantity: 0,
    controlType: getControlType(position),
    addonGroups: position.addonGroups.map((addonGroup) => ({
        ...addonGroup,
        virtualId: uuidv4(),
        controlType: getControlType(addonGroup),
        addons: addonGroup.addons.map(prepareConfigurablePosition)
    }))
});
